// Generated by script/generate-logo-assets.tsx. Do not edit.
// Run: npm run generate-logo-assets -w @github-ui/swp-flex-suite
import logo3M from './3-m.svg'
import logoAccenture from './accenture.svg'
import logoAdobe from './adobe.svg'
import logoAi21Labs from './ai21-labs.svg'
import logoAmd from './amd.svg'
import logoAmericanAirlines from './american-airlines.svg'
import logoAmplifon from './amplifon.svg'
import logoAnthropic from './anthropic.svg'
import logoAsos from './asos.svg'
import logoAstraZeneca from './astra-zeneca.svg'
import logoAtT from './at-t.svg'
import logoAzure from './azure.svg'
import logoBlackForestLabs from './black-forest-labs.svg'
import logoBolt from './bolt.svg'
import logoCarlsbergGroup from './carlsberg-group.svg'
import logoCocaCola from './coca-cola.svg'
import logoCognizant from './cognizant.svg'
import logoCohere from './cohere.svg'
import logoCoinbase from './coinbase.svg'
import logoCoyoteLogistic from './coyote-logistic.svg'
import logoDatadog from './datadog.svg'
import logoDecathlon from './decathlon.svg'
import logoDeepSeek from './deep-seek.svg'
import logoDeutscheVermGensberatung from './deutsche-verm-gensberatung.svg'
import logoDoctolib from './doctolib.svg'
import logoDocuSign from './docu-sign.svg'
import logoDowJones from './dow-jones.svg'
import logoDuolingo from './duolingo.svg'
import logoEclipseIde from './eclipse-ide.svg'
import logoElanco from './elanco.svg'
import logoErnstAndYoung from './ernst-and-young.svg'
import logoEtched from './etched.svg'
import logoEtsy from './etsy.svg'
import logoEvolent from './evolent.svg'
import logoFedEx from './fed-ex.svg'
import logoFidelity from './fidelity.svg'
import logoFord from './ford.svg'
import logoGeneralMotors from './general-motors.svg'
import logoGitHub from './git-hub.svg'
import logoGoogle from './google.svg'
import logoGrupoBoticRio from './grupo-botic-rio.svg'
import logoHM from './h-m.svg'
import logoHashicorp from './hashicorp.svg'
import logoHebbia from './hebbia.svg'
import logoHomeDepot from './home-depot.svg'
import logoHp from './hp.svg'
import logoHsbc from './hsbc.svg'
import logoInfosys from './infosys.svg'
import logoIntel from './intel.svg'
import logoItau from './itau.svg'
import logoJetBrains from './jet-brains.svg'
import logoKpmg from './kpmg.svg'
import logoLinkedIn from './linked-in.svg'
import logoMercadoLibre from './mercado-libre.svg'
import logoMercedesBenz from './mercedes-benz.svg'
import logoMeta from './meta.svg'
import logoMicrosoft from './microsoft.svg'
import logoMicrosoftCopilot from './microsoft-copilot.svg'
import logoMistralAi from './mistral-ai.svg'
import logoNasa from './nasa.svg'
import logoNeovim from './neovim.svg'
import logoOpenAi from './open-ai.svg'
import logoOttoGroup from './otto-group.svg'
import logoPhilips from './philips.svg'
import logoPhysicalIntelligence from './physical-intelligence.svg'
import logoPlaid from './plaid.svg'
import logoPostmates from './postmates.svg'
import logoProcterAndGamble from './procter-and-gamble.svg'
import logoRaycast from './raycast.svg'
import logoSPGlobalMarketIntelligence from './s-p-global-market-intelligence.svg'
import logoShopify from './shopify.svg'
import logoSocieteGenerale from './societe-generale.svg'
import logoSpotify from './spotify.svg'
import logoStripe from './stripe.svg'
import logoSurgeAi from './surge-ai.svg'
import logoTelus from './telus.svg'
import logoTwilio from './twilio.svg'
import logoVercel from './vercel.svg'
import logoVisualStudio from './visual-studio.svg'
import logoVisualStudioCode from './visual-studio-code.svg'
import logoVodafone from './vodafone.svg'
import logoWex from './wex.svg'
import logoXAi from './x-ai.svg'
import logoXcode from './xcode.svg'
import logoZendesk from './zendesk.svg'

const logoUrlMap = {
  '3M': logo3M,
  Accenture: logoAccenture,
  Adobe: logoAdobe,
  'AI21 Labs': logoAi21Labs,
  AMD: logoAmd,
  'American Airlines': logoAmericanAirlines,
  Amplifon: logoAmplifon,
  Anthropic: logoAnthropic,
  ASOS: logoAsos,
  AstraZeneca: logoAstraZeneca,
  'AT&T': logoAtT,
  Azure: logoAzure,
  'Black Forest Labs': logoBlackForestLabs,
  Bolt: logoBolt,
  'Carlsberg Group': logoCarlsbergGroup,
  'Coca-Cola': logoCocaCola,
  Cognizant: logoCognizant,
  Cohere: logoCohere,
  Coinbase: logoCoinbase,
  'Coyote Logistic': logoCoyoteLogistic,
  Datadog: logoDatadog,
  Decathlon: logoDecathlon,
  DeepSeek: logoDeepSeek,
  'Deutsche Vermögensberatung': logoDeutscheVermGensberatung,
  Doctolib: logoDoctolib,
  DocuSign: logoDocuSign,
  'Dow Jones': logoDowJones,
  Duolingo: logoDuolingo,
  'Eclipse IDE': logoEclipseIde,
  Elanco: logoElanco,
  'Ernst and Young': logoErnstAndYoung,
  Etched: logoEtched,
  Etsy: logoEtsy,
  Evolent: logoEvolent,
  FedEx: logoFedEx,
  Fidelity: logoFidelity,
  Ford: logoFord,
  'General Motors': logoGeneralMotors,
  GitHub: logoGitHub,
  Google: logoGoogle,
  'Grupo Boticário': logoGrupoBoticRio,
  'H&M': logoHM,
  Hashicorp: logoHashicorp,
  Hebbia: logoHebbia,
  'Home Depot': logoHomeDepot,
  HP: logoHp,
  HSBC: logoHsbc,
  Infosys: logoInfosys,
  Intel: logoIntel,
  Itau: logoItau,
  JetBrains: logoJetBrains,
  KPMG: logoKpmg,
  LinkedIn: logoLinkedIn,
  'Mercado Libre': logoMercadoLibre,
  'Mercedes Benz': logoMercedesBenz,
  Meta: logoMeta,
  Microsoft: logoMicrosoft,
  'Microsoft Copilot': logoMicrosoftCopilot,
  'Mistral AI': logoMistralAi,
  Nasa: logoNasa,
  Neovim: logoNeovim,
  OpenAI: logoOpenAi,
  'Otto Group': logoOttoGroup,
  Philips: logoPhilips,
  'Physical Intelligence': logoPhysicalIntelligence,
  Plaid: logoPlaid,
  Postmates: logoPostmates,
  'Procter and Gamble': logoProcterAndGamble,
  Raycast: logoRaycast,
  'S&P Global Market Intelligence': logoSPGlobalMarketIntelligence,
  Shopify: logoShopify,
  'Societe Generale': logoSocieteGenerale,
  Spotify: logoSpotify,
  Stripe: logoStripe,
  SurgeAI: logoSurgeAi,
  Telus: logoTelus,
  Twilio: logoTwilio,
  Vercel: logoVercel,
  'Visual Studio': logoVisualStudio,
  'Visual Studio Code': logoVisualStudioCode,
  Vodafone: logoVodafone,
  WEX: logoWex,
  xAI: logoXAi,
  Xcode: logoXcode,
  Zendesk: logoZendesk,
} satisfies Record<string, string>

function isValidLogo(name: string): name is keyof typeof logoUrlMap {
  return Object.hasOwn(logoUrlMap, name)
}

export function getLogoUrl(name: string): string | null {
  return isValidLogo(name) ? logoUrlMap[name] : null
}
